import NotableConcepts from "Explore/Pages/InstitutionDetail/Components/NotableConcepts";
import { getUnitTopRankingKeywords } from "Explore/Services/Unit";
import useExploreInfo from "Hooks/useExploreInfo";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setExploringKeyword } from "Redux/Slices/Concept";
import styles from "./UnitNotableConcepts.module.scss";

const UnitNotableConcepts = ({ onKeywordClickCallback }) => {
  const { entity_id: id } = useExploreInfo();
  const [data, setData] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    getUnitTopRankingKeywords({ id })
      .then((res) => {
        setData(res);
      })
      .catch((err) => {
        console.log(err);
        setData([]);
      });
  }, [id]);

  const onClickExploreKeyword = (keyword) => {
    dispatch(setExploringKeyword(keyword));
    onKeywordClickCallback?.();
  };

  if (!data || (data?.top_keywords?.length === 0 && data?.top_ranking_keywords?.length === 0)) {
    return null;
  }

  return (
    <div className={styles["notable-concepts-wrapper"]}>
      <NotableConcepts
        notableConcepts={data}
        onClickExploreKeywordCallback={onClickExploreKeyword}
      />
    </div>
  );
};

export default UnitNotableConcepts;

